document.addEventListener("DOMContentLoaded", function () {
    const addToCartButton = document.querySelector(".product-form__buttons .product-form__submit");
    const stickyCta = document.getElementById("sticky-cta");

    if (!addToCartButton || !stickyCta) return;

    // Start with the sticky CTA hidden
    stickyCta.style.display = "none";

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const isVisible = entry.isIntersecting;

                if (isVisible) {
                    stickyCta.style.display = "none"; // Always hide when Add to Cart is in view
                } else {
                    // Only show if we've scrolled *past* the Add to Cart section
                    const addToCartTop = addToCartButton.getBoundingClientRect().top + window.scrollY;
                    const scrollY = window.scrollY;

                    if (scrollY > addToCartTop) {
                        stickyCta.style.display = "block";
                    } else {
                        stickyCta.style.display = "none";
                    }
                }
            });
        },
        {
            threshold: 0.1
        }
    );

    observer.observe(addToCartButton);

    // Extra check when user scrolls to bottom of page
    window.addEventListener("scroll", function () {
        const scrollBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 10;
        const addToCartInView = addToCartButton.getBoundingClientRect().top < window.innerHeight &&
                                addToCartButton.getBoundingClientRect().bottom >= 0;

        if (scrollBottom && !addToCartInView) {
            stickyCta.style.display = "block";
        }
    });
});

/* Vitasource 2026-10-12 (Eric): Phenetrine sticky bar with pack picker + Add to Cart. Shows only after the page Add to Cart button has scrolled up out of view. Replaces the "Start Losing Weight Today" sticky on Phenetrine only. */
(function () {
  var PACKS = [
    { id: '45940518977777', title: '1 Bottle', label: '1 Bottle', per: '$59', supply: '30-Day Supply', lose: 'Lose Avg. 5-8 lbs', was: '$79', now: '$59' },
    { id: '45940519010545', title: '3 Bottles', label: '3 Bottles', per: '$33', supply: '90-Day Supply', lose: 'Lose Avg. 15-25 lbs', was: '$237', now: '$99' },
    { id: '46134384558321', title: '6 Bottles', label: '6 Bottles', per: '$25', supply: '180-Day Supply', lose: 'Lose Avg. 30-48 lbs', was: '$474', now: '$150' }
  ];

  function isPhenetrine() {
    if (/\/products\/phenetrine\/?$/.test(window.location.pathname)) return true;
    return !!document.querySelector('[data-variant-id="45940518977777"], input[name="id"][value="45940518977777"]');
  }

  function init() {
    if (window.vsPhenSticky || !isPhenetrine()) return;
    window.vsPhenSticky = 1;

    var css = '' +
      'body.vs-ps-on #sticky-cta{display:none !important}' +
      'body.vs-ps-on{padding-bottom:92px}' +
      '.vs-ps,.vs-ps *{box-sizing:border-box;font-family:"Archivo",system-ui,-apple-system,sans-serif}' +
      '.vs-ps-bar{transition:transform .45s cubic-bezier(.22,1,.36,1),opacity .35s ease;transform:translateY(0);opacity:1;will-change:transform,opacity}' +
      '.vs-ps.vs-ps-off .vs-ps-bar{transform:translateY(115%);opacity:0;pointer-events:none;transition:transform .35s cubic-bezier(.4,0,.2,1),opacity .3s ease}' +
      '.vs-ps.vs-ps-off .vs-ps-dim{display:none !important}' +
      '.vs-ps-bar{position:fixed;left:0;right:0;bottom:0;z-index:9990;background:#fff;border-top:1px solid #e5e7eb;box-shadow:0 -6px 18px rgba(17,24,39,.08);padding:12px 12px calc(12px + env(safe-area-inset-bottom,0px))}' +
      '.vs-ps-row{display:flex;gap:10px;align-items:stretch;max-width:560px;margin:0 auto;height:56px}' +
      '@media (min-width:750px){.vs-ps-row{max-width:none;gap:16px}.vs-ps-pick{width:220px}.vs-ps-sheet{right:auto;width:520px;border-radius:18px 18px 0 0}}' +
      '.vs-ps-pick{width:132px;flex-shrink:0;border:2px solid #1d4ed8;border-radius:10px;background:#fff;padding:0 10px 0 12px;display:flex;align-items:center;justify-content:space-between;gap:6px;cursor:pointer;color:#111827;margin:0}' +
      '.vs-ps-pick b{display:block;font-size:16px;font-weight:800;color:#111827;white-space:nowrap;line-height:1.15;text-align:left}' +
      '.vs-ps-pick small{display:block;font-size:12px;color:#4b5563;white-space:nowrap;line-height:1.2;text-align:left}' +
      '.vs-ps-pick svg{transition:transform .2s;transform:rotate(0deg)}' +
      '.vs-ps.open .vs-ps-pick svg{transform:rotate(180deg)}' +
      '.vs-ps-atc{flex:1;min-width:0;border:0;border-radius:10px;background:#1d4ed8;color:#fff;font-size:17px;font-weight:800;letter-spacing:.4px;cursor:pointer;margin:0;padding:0 8px}' +
      '.vs-ps-atc:hover{background:#1e40af}' +
      '.vs-ps-atc[disabled]{opacity:.7;cursor:wait}' +
      '.vs-ps-dim{display:none;position:fixed;inset:0;z-index:9988;background:rgba(17,24,39,.5);border:0;padding:0;margin:0;cursor:pointer;width:100%;height:100%}' +
      '.vs-ps-sheet{display:none;position:absolute;left:0;right:0;bottom:100%;margin-bottom:-1px;z-index:2;background:#fff;border-radius:18px 18px 0 0;padding:18px 16px 14px;box-shadow:0 -8px 24px rgba(17,24,39,.18);max-height:calc(100vh - 120px);overflow:auto}' +
      '.vs-ps.open .vs-ps-dim,.vs-ps.open .vs-ps-sheet{display:block}' +
      '.vs-ps-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}' +
      '.vs-ps-head span{font-size:20px;font-weight:800;color:#1e3a8a}' +
      '.vs-ps-x{width:44px;height:44px;border:0;background:transparent;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#4b5563;margin:0;padding:0}' +
      '.vs-ps-opt{display:flex;justify-content:space-between;align-items:center;gap:12px;width:100%;padding:14px 16px;border-radius:10px;cursor:pointer;background:#fff;border:3px solid #e2e4e8;margin:0 0 10px;text-align:left;color:#111827}' +
      '.vs-ps-opt:last-child{margin-bottom:0}' +
      '.vs-ps-opt[aria-selected="true"]{background:#eff4ff;border-color:#1d6fe0}' +
      '.vs-ps-l b{display:block;font-size:19px;font-weight:700;color:#111827;line-height:1.2}' +
      '.vs-ps-l span{display:block;font-size:15px;color:#4b5563;line-height:1.3}' +
      '.vs-ps-l span em{font-style:normal;color:#111827;font-weight:600}' +
      '.vs-ps-l small{display:block;font-size:13px;color:#4b5563;line-height:1.3}' +
      '.vs-ps-r{text-align:right;flex-shrink:0}' +
      '.vs-ps-r s{display:block;font-size:15px;color:#6b7280}' +
      '.vs-ps-r b{display:block;font-size:22px;font-weight:800;color:#111827;line-height:1.1}';

    var font = document.createElement('link');
    font.rel = 'stylesheet';
    font.href = 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;600;700;800&display=swap';
    document.head.appendChild(font);
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);

    var chev = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1d4ed8" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 15l6-6 6 6"></path></svg>';
    var opts = PACKS.map(function (p) {
      return '<button type="button" class="vs-ps-opt" role="option" aria-selected="false" data-id="' + p.id + '">' +
        '<span class="vs-ps-l"><b>' + p.label + '</b><span><em>' + p.per + '</em> Per Bottle · ' + p.supply + '</span><small>' + p.lose + '</small></span>' +
        '<span class="vs-ps-r"><s>' + p.was + '</s><b>' + p.now + '</b></span></button>';
    }).join('');

    var root = document.createElement('div');
    root.className = 'vs-ps vs-ps-off';
    root.innerHTML =
      '<button type="button" class="vs-ps-dim" aria-label="Close options"></button>' +
      '<div class="vs-ps-bar">' +
      '<div class="vs-ps-sheet" role="listbox" aria-label="Select option">' +
        '<div class="vs-ps-head"><span>Select option:</span><button type="button" class="vs-ps-x" aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg></button></div>' +
        opts +
      '</div>' +
      '<div class="vs-ps-row">' +
        '<button type="button" class="vs-ps-pick" aria-haspopup="listbox" aria-expanded="false" aria-label="Choose bottle quantity"><span><b class="vs-ps-cl"></b><small class="vs-ps-cp"></small></span>' + chev + '</button>' +
        '<button type="button" class="vs-ps-atc">ADD TO CART</button>' +
      '</div></div>';
    document.body.appendChild(root);
    document.body.classList.add('vs-ps-on');

    var pick = root.querySelector('.vs-ps-pick');
    var atc = root.querySelector('.vs-ps-atc');
    var sel = PACKS[0];

    function mainId() {
      var i = document.querySelector('form[id^="product-form-"] input[name="id"]');
      return i ? String(i.value) : null;
    }
    function render() {
      root.querySelector('.vs-ps-cl').textContent = sel.label;
      root.querySelector('.vs-ps-cp').textContent = sel.per + '/bottle';
      root.querySelectorAll('.vs-ps-opt').forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-id') === sel.id ? 'true' : 'false');
      });
    }
    function setOpen(on) {
      root.classList.toggle('open', on);
      pick.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function fromMain() {
      var id = mainId();
      for (var i = 0; i < PACKS.length; i++) if (PACKS[i].id === id) { sel = PACKS[i]; render(); return; }
    }
    function selectMain(p) {
      var vs = document.querySelector('variant-selects');
      if (!vs) return;
      var target = null;
      vs.querySelectorAll('input.variant-input').forEach(function (r) {
        if (r.value.trim() === p.title && !r.hasAttribute('selling-plan')) target = r;
      });
      if (!target || (target.checked && mainId() === p.id)) return;
      target.checked = true;
      var had = vs.hasAttribute('data-update-url');
      vs.setAttribute('data-update-url', 'false');
      target.dispatchEvent(new Event('change', { bubbles: true }));
      if (!had) vs.removeAttribute('data-update-url');
    }
    function fallbackAdd() {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(sel.id), quantity: 1 }] }) })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { window.location.href = '/cart/' + sel.id + ':1'; });
    }

    pick.addEventListener('click', function () { setOpen(!root.classList.contains('open')); });
    root.querySelector('.vs-ps-dim').addEventListener('click', function () { setOpen(false); });
    root.querySelector('.vs-ps-x').addEventListener('click', function () { setOpen(false); });
    root.querySelectorAll('.vs-ps-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-id');
        PACKS.forEach(function (p) { if (p.id === id) sel = p; });
        render();
        setOpen(false);
        selectMain(sel);
      });
    });
    atc.addEventListener('click', function () {
      setOpen(false);
      selectMain(sel);
      var btn = document.querySelector('form[id^="product-form-"] .product-form__submit') || document.querySelector('.product-form__buttons .product-form__submit');
      if (!btn) { fallbackAdd(); return; }
      atc.disabled = true;
      var tries = 0;
      (function go() {
        if (mainId() === sel.id || tries > 20) {
          atc.disabled = false;
          if (mainId() === sel.id && !btn.disabled) btn.click(); else fallbackAdd();
          return;
        }
        tries++;
        setTimeout(go, 75);
      })();
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(fromMain, 60);
    });

    var row = root.querySelector('.vs-ps-row');
    var sheet = root.querySelector('.vs-ps-sheet');
    function layout() {
      var vw = document.documentElement.clientWidth;
      if (window.innerWidth < 750) {
        row.style.marginLeft = row.style.marginRight = '';
        sheet.style.left = sheet.style.width = '';
        return;
      }
      var pw = document.querySelector('#MainContent .page-width');
      if (!pw) return;
      var r = pw.getBoundingClientRect();
      var cs = getComputedStyle(pw);
      var cRight = r.right - parseFloat(cs.paddingRight);
      var cLeft = r.left + parseFloat(cs.paddingLeft);
      var col = document.querySelector('variant-selects');
      var w = 560;
      if (col) { var cr = col.getBoundingClientRect(); if (cr.width > 200) w = Math.round(cRight - cr.left); }
      w = Math.max(360, Math.min(w, cRight - cLeft));
      var right = Math.max(0, vw - cRight - 12);
      var left = Math.max(0, vw - 24 - right - w);
      row.style.marginLeft = left + 'px';
      row.style.marginRight = right + 'px';
      sheet.style.left = (left + 12) + 'px';
      sheet.style.width = w + 'px';
    }
    window.addEventListener('resize', layout);
    layout();
    setTimeout(layout, 800);

    var shown = false;
    function mainBtn() {
      return document.querySelector('form[id^="product-form-"] .product-form__submit') || document.querySelector('.product-form__buttons .product-form__submit');
    }
    function vis() {
      var btn = mainBtn();
      var on = true;
      if (btn) { var r = btn.getBoundingClientRect(); if (r.height > 0 || r.width > 0) on = r.bottom < 0; }
      if (on === shown) return;
      shown = on;
      root.classList.toggle('vs-ps-off', !on);
      if (!on) setOpen(false);
    }
    var tick = false;
    function onScroll() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; vis(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    vis();
    setTimeout(vis, 800);

    fromMain();
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  else init();
})();
